import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/Jobs/Checklist'

export default createChildListViewContainer()(Component)
